import { LowInformationsDTO } from 'src/app/shared/interfaces';

export class LowInformations implements LowInformationsDTO {
  id: number;
  nom: string;
  prenom: string;
  typeSociete: boolean;
  nePlusUtiliser: boolean;
  typeContactID: number;
  userId: number;
  userActive: boolean;
  contactParentId: number;
  contactParent: string;
  adressePrincipaleId: number;
  adressePrincipale: {
    id: number;
    structure_Localite: {
      id: number;
      codePostal: string;
      localite: string;
      pays: {
        id: number;
        codePays: string;
        description: string;
      };
    };
    structure_Rue: {
      id: number;
      codePostal: string;
      codeRue: string;
      codeLangue: string;
      rueNom: string;
    };
    structure_RueNumero: string;
    structure_RueBoite: string;
    langueId: number;
    impression_Adresse: string;
    impression_CodePostal: string;
    impression_Localite: string;
    impression_Pays: string;
    telephone: string;
    fax: string;
    gsm: string;
    site: string;
    mail: string;
  };
  verrouille: boolean;
  baseSurContact: number;

  name: string;
  label: string;
  value: number;
  constructor(data: LowInformationsDTO) {
    Object.assign(this, data);
    this.name = this.setName(this.nom, this.prenom);
    this.label = this.name;
    this.value = this.id;
  }

  public setName(lastName: string, firstName: string): string {
    return `${lastName || ''} ${firstName || ''}`;
  }
}
